/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationV2ShotType } from './MatchOperationV2ShotType';
import {
    MatchOperationV2ShotTypeFromJSON,
    MatchOperationV2ShotTypeFromJSONTyped,
    MatchOperationV2ShotTypeToJSON,
    MatchOperationV2ShotTypeToJSONTyped,
} from './MatchOperationV2ShotType';
import type { MatchOperationV2ShotOutcome } from './MatchOperationV2ShotOutcome';
import {
    MatchOperationV2ShotOutcomeFromJSON,
    MatchOperationV2ShotOutcomeFromJSONTyped,
    MatchOperationV2ShotOutcomeToJSON,
    MatchOperationV2ShotOutcomeToJSONTyped,
} from './MatchOperationV2ShotOutcome';
import type { MatchOperationV2TeamSide } from './MatchOperationV2TeamSide';
import {
    MatchOperationV2TeamSideFromJSON,
    MatchOperationV2TeamSideFromJSONTyped,
    MatchOperationV2TeamSideToJSON,
    MatchOperationV2TeamSideToJSONTyped,
} from './MatchOperationV2TeamSide';

/**
 * 
 * @export
 * @interface PublicMatchOperationV2Event
 */
export interface PublicMatchOperationV2Event {
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Event
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2Event
     */
    revision: number;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Event
     */
    type: PublicMatchOperationV2EventType;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2Event
     */
    period?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2Event
     */
    periodElapsedMs?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PublicMatchOperationV2Event
     */
    effectiveElapsedMs?: number | null;
    /**
     * 
     * @type {MatchOperationV2TeamSide}
     * @memberof PublicMatchOperationV2Event
     */
    teamSide?: MatchOperationV2TeamSide;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Event
     */
    teamId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Event
     */
    participantId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Event
     */
    targetEventId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PublicMatchOperationV2Event
     */
    occurredAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PublicMatchOperationV2Event
     */
    recordedAt: Date;
    /**
     * 
     * @type {MatchOperationV2ShotOutcome}
     * @memberof PublicMatchOperationV2Event
     */
    shotOutcome?: MatchOperationV2ShotOutcome | null;
    /**
     * 
     * @type {MatchOperationV2ShotType}
     * @memberof PublicMatchOperationV2Event
     */
    shotType?: MatchOperationV2ShotType | null;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Event
     */
    goalkeeperParticipantId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicMatchOperationV2Event
     */
    defenderParticipantId?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum PublicMatchOperationV2EventType {
    ClockStarted = 'CLOCK_STARTED',
    ClockPaused = 'CLOCK_PAUSED',
    ClockAdjusted = 'CLOCK_ADJUSTED',
    PeriodCompleted = 'PERIOD_COMPLETED',
    PeriodInitialized = 'PERIOD_INITIALIZED',
    GoalRecorded = 'GOAL_RECORDED',
    PenaltyGoalRecorded = 'PENALTY_GOAL_RECORDED',
    ShotMissedRecorded = 'SHOT_MISSED_RECORDED',
    ShotSavedRecorded = 'SHOT_SAVED_RECORDED',
    ShotAttemptRecorded = 'SHOT_ATTEMPT_RECORDED',
    TurnoverRecorded = 'TURNOVER_RECORDED',
    TechnicalFaultRecorded = 'TECHNICAL_FAULT_RECORDED',
    LostBallRecorded = 'LOST_BALL_RECORDED',
    GoalkeeperDesignated = 'GOALKEEPER_DESIGNATED',
    GoalkeeperDesignationRemoved = 'GOALKEEPER_DESIGNATION_REMOVED',
    ActiveGoalkeeperChanged = 'ACTIVE_GOALKEEPER_CHANGED',
    TeamTimeoutRecorded = 'TEAM_TIMEOUT_RECORDED',
    TwoMinuteSuspensionRecorded = 'TWO_MINUTE_SUSPENSION_RECORDED',
    YellowCardRecorded = 'YELLOW_CARD_RECORDED',
    RedCardRecorded = 'RED_CARD_RECORDED',
    BlueCardRecorded = 'BLUE_CARD_RECORDED',
    EventVoided = 'EVENT_VOIDED',
    EventReplaced = 'EVENT_REPLACED',
    FinalResultRecorded = 'FINAL_RESULT_RECORDED',
    MatchFinished = 'MATCH_FINISHED',
    MatchReopened = 'MATCH_REOPENED'
}


/**
 * Check if a given object implements the PublicMatchOperationV2Event interface.
 */
export function instanceOfPublicMatchOperationV2Event(value: object): value is PublicMatchOperationV2Event {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('occurredAt' in value) || value['occurredAt'] === undefined) return false;
    if (!('recordedAt' in value) || value['recordedAt'] === undefined) return false;
    return true;
}

export function PublicMatchOperationV2EventFromJSON(json: any): PublicMatchOperationV2Event {
    return PublicMatchOperationV2EventFromJSONTyped(json, false);
}

export function PublicMatchOperationV2EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicMatchOperationV2Event {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'revision': json['revision'],
        'type': json['type'],
        'period': json['period'] == null ? undefined : json['period'],
        'periodElapsedMs': json['periodElapsedMs'] == null ? undefined : json['periodElapsedMs'],
        'effectiveElapsedMs': json['effectiveElapsedMs'] == null ? undefined : json['effectiveElapsedMs'],
        'teamSide': json['teamSide'] == null ? undefined : MatchOperationV2TeamSideFromJSON(json['teamSide']),
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'participantId': json['participantId'] == null ? undefined : json['participantId'],
        'targetEventId': json['targetEventId'] == null ? undefined : json['targetEventId'],
        'occurredAt': (new Date(json['occurredAt'])),
        'recordedAt': (new Date(json['recordedAt'])),
        'shotOutcome': json['shotOutcome'] == null ? undefined : MatchOperationV2ShotOutcomeFromJSON(json['shotOutcome']),
        'shotType': json['shotType'] == null ? undefined : MatchOperationV2ShotTypeFromJSON(json['shotType']),
        'goalkeeperParticipantId': json['goalkeeperParticipantId'] == null ? undefined : json['goalkeeperParticipantId'],
        'defenderParticipantId': json['defenderParticipantId'] == null ? undefined : json['defenderParticipantId'],
    };
}

export function PublicMatchOperationV2EventToJSON(json: any): PublicMatchOperationV2Event {
    return PublicMatchOperationV2EventToJSONTyped(json, false);
}

export function PublicMatchOperationV2EventToJSONTyped(value?: PublicMatchOperationV2Event | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'revision': value['revision'],
        'type': value['type'],
        'period': value['period'],
        'periodElapsedMs': value['periodElapsedMs'],
        'effectiveElapsedMs': value['effectiveElapsedMs'],
        'teamSide': MatchOperationV2TeamSideToJSON(value['teamSide']),
        'teamId': value['teamId'],
        'participantId': value['participantId'],
        'targetEventId': value['targetEventId'],
        'occurredAt': value['occurredAt'].toISOString(),
        'recordedAt': value['recordedAt'].toISOString(),
        'shotOutcome': MatchOperationV2ShotOutcomeToJSON(value['shotOutcome']),
        'shotType': MatchOperationV2ShotTypeToJSON(value['shotType']),
        'goalkeeperParticipantId': value['goalkeeperParticipantId'],
        'defenderParticipantId': value['defenderParticipantId'],
    };
}

